import { connect } from 'react-redux';
import { IState } from '../../../reducers';
import { fetchFooterAction } from './actions/fetchFooter';
import { Footer } from './footer';

const mapStateToProps = (state: IState) => ({
    footer: state.footer
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchFooter: () => dispatch(fetchFooterAction()),
});

export const FooterContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Footer);


// WEBPACK FOOTER //
// ./src/common/components/footer/footerContainer.tsx